import React, { useState } from "react";
import "./SocialSideBar.css";
import { FaWhatsapp, FaTelegramPlane, FaEnvelope } from "react-icons/fa";

const SocialSideBar = () => {
  const [active, setActive] = useState(null);

  const links = [
    {
      id: "whatsapp",
      icon: <FaWhatsapp className="icon" />,
      text: "WhatsApp Us",
      url: "https://wa.me/918287648766", // change your number
      color: "whatsapp",
    },
    /*{
      id: "telegram",
      icon: <FaTelegramPlane className="icon" />,
      text: "Telegram",
      url: "https://t.me/+817083110880", // change your username
      color: "telegram",
    },*/
    {
      id: "email",
      icon: <FaEnvelope className="icon" />,
      text: "Email Us",
      url: "mailto:prepxpathshala@example.com", // change your email
      color: "email",
    },
  ];

  return (
    <div className="social-sidebar">
      {links.map((link) => (
        <a
          key={link.id}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`social-link ${link.color} ${
            active === link.id ? "active" : ""
          }`}
          onMouseEnter={() => setActive(link.id)}
          onMouseLeave={() => setActive(null)}
          onTouchStart={() =>
            setActive(active === link.id ? null : link.id)
          }
        >
          {link.icon}
          <span className="text">{link.text}</span>
        </a>
      ))}
    </div>
  );
};

export default SocialSideBar;
